// extracted by mini-css-extract-plugin
export default {"mega_loading_wrapper":"megaLoading_mega_loading_wrapper__kK9T7","mega_loading":"megaLoading_mega_loading__wWI1Q"};